"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exponencial = void 0;
var exponencial = {
  name: 'Exponencial',
  link: '/exponencial/',
  logo: 'Exponencial',
  colors: {
    active: 'fontNeutral90',
    font: 'fontNeutral60',
    background: 'backgroundNeutral10'
  },
  links: [{
    id: 'controle-financeiro',
    label: 'Controle financeiro',
    link: '/exponencial/controle-financeiro/'
  }, {
    id: 'realizando-sonhos',
    label: 'Realizando sonhos',
    link: '/exponencial/realizando-sonhos/'
  }, {
    id: 'saia-do-vermelho',
    label: 'Saia do Vermelho',
    link: '/exponencial/saia-do-vermelho/'
  }, {
    id: 'me-explica',
    label: 'Me explica Creditas',
    link: '/exponencial/me-explica/'
  }, {
    id: 'credito',
    label: 'Tudo sobre Crédito',
    link: '/exponencial/credito/'
  }, {
    id: 'meu-negocio',
    label: 'Meu negócio',
    link: '/exponencial/meu-negocio/'
  }]
};
exports.exponencial = exponencial;